'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  display: ', ';\n'], ['\n  position: relative;\n  display: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  width: ', ';\n  pointer-events: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  transform: ', ';\n  top: calc(100% + 5px);\n  position: absolute;\n  z-index: 10;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n  width: ', ';\n  pointer-events: ', ';\n  opacity: ', ';\n  visibility: ', ';\n  transform: ', ';\n  top: calc(100% + 5px);\n  position: absolute;\n  z-index: 10;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n      ', ': 0px;\n    '], ['\n      ', ': 0px;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100vh;\n    transform: none;\n    position: fixed;\n    top: 0px;\n    z-index: 100000000000000000;\n    overflow: hidden;\n    background: rgba(255, 255, 255, .8);\n    display: flex;\n    align-items: center;\n  '], ['\n    width: 100%;\n    height: 100vh;\n    transform: none;\n    position: fixed;\n    top: 0px;\n    z-index: 100000000000000000;\n    overflow: hidden;\n    background: rgba(255, 255, 255, .8);\n    display: flex;\n    align-items: center;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n  width: 100%;\n  z-index: 5;\n\n  ', ';\n'], ['\n  width: 100%;\n  z-index: 5;\n\n  ', ';\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    width: 100%;\n    max-height: 75vh;\n    overflow: auto;\n    transform: ', ';\n    box-shadow: 0 -1px 8px 0 rgba(0, 0, 0, 0.15);\n    position: relative;\n    z-index: 1;\n\n    ', ';\n  '], ['\n    width: 100%;\n    max-height: 75vh;\n    overflow: auto;\n    transform: ', ';\n    box-shadow: 0 -1px 8px 0 rgba(0, 0, 0, 0.15);\n    position: relative;\n    z-index: 1;\n\n    ', ';\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100vh;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: none;\n\n  ', ';\n'], ['\n  width: 100%;\n  height: 100vh;\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: none;\n\n  ', ';\n']),
    _templateObject8 = _taggedTemplateLiteral(['display: block;'], ['display: block;']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _windowScrollBlocker = require('../../libs/windowScrollBlocker');

var _windowScrollBlocker2 = _interopRequireDefault(_windowScrollBlocker);

var _assetsContainer = require('../../libs/assetsContainer');

var _Portal = require('../Portal/Portal');

var _Portal2 = _interopRequireDefault(_Portal);

var _media = require('../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Libs
// Components
// Styles


var DropDownContainer = _styledComponents2.default.span(_templateObject, function (_ref) {
  var block = _ref.block;
  return block ? 'block' : 'inline-block';
});

var StyledDropDown = _styledComponents2.default.div(_templateObject2, function (_ref2) {
  var width = _ref2.width;
  return width + 'px';
}, function (_ref3) {
  var visible = _ref3.visible;
  return visible ? 'auto' : 'none';
}, function (_ref4) {
  var visible = _ref4.visible;
  return visible ? 1 : 0;
}, function (_ref5) {
  var visible = _ref5.visible;
  return visible ? 'visible' : 'hidden';
}, function (_ref6) {
  var visible = _ref6.visible;
  return visible ? 'none' : 'translateY(-15px)';
}, (0, _polished.transitions)('opacity .2s ease-in-out', 'visibility .2s ease-in-out', 'transform .2s ease-in-out'), function (_ref7) {
  var position = _ref7.position;
  return (0, _styledComponents.css)(_templateObject3, position);
}, _media.media.s(_templateObject4));

var DropDownContent = _styledComponents2.default.div(_templateObject5, _media.media.s(_templateObject6, function (_ref8) {
  var visible = _ref8.visible;
  return visible ? 'none' : 'translateY(100%)';
}, (0, _polished.transitions)('transform .2s ease-in-out')));

var ClickArea = _styledComponents2.default.div(_templateObject7, _media.media.s(_templateObject8));

var DropDown = function (_Component) {
  _inherits(DropDown, _Component);

  function DropDown() {
    var _ref9;

    var _temp, _this, _ret;

    _classCallCheck(this, DropDown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref9 = DropDown.__proto__ || Object.getPrototypeOf(DropDown)).call.apply(_ref9, [this].concat(args))), _this), _this.state = {
      position: 'left'
    }, _this.freeScroll = null, _this.handlePosition = function () {
      if (!_this.dom || (0, _media.isDeviceSize)('s')) return;
      var windowWidth = window.innerWidth;

      var dom = _this.dom.getBoundingClientRect();

      var spaceOnRight = windowWidth - (dom.x + _this.props.size);
      var spaceOnLeft = dom.x + dom.width - _this.props.size;
      if (spaceOnRight >= 0) return _this.setState({
        position: 'left'
      });
      if (spaceOnLeft >= 0) return _this.setState({
        position: 'right'
      });
      var position = spaceOnRight >= spaceOnLeft ? 'left' : 'right';

      _this.setState({
        position: position
      });
    }, _this.handleClickOutside = function () {
      if ((0, _media.isDeviceSize)('s')) return;

      _this.onClose();
    }, _this.onClose = function () {
      var _this$props = _this.props,
          visible = _this$props.visible,
          onClose = _this$props.onClose;
      visible && onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropDown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleWindow(false, this.props.visible);
      if (this.props.visible) this.handlePosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this.handleWindow(prevProps.visible, this.props.visible);
      if (!prevProps.visible && this.props.visible) this.handlePosition();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.handleWindow(this.props.visible, false);
    }
  }, {
    key: 'handleWindow',
    value: function handleWindow(previousShow, currentShow) {
      if (!(0, _media.isDeviceSize)('s')) return;

      if (!previousShow && currentShow) {
        this.freeScroll = _windowScrollBlocker2.default.add();
      } else if (previousShow && !currentShow && this.freeScroll) {
        this.freeScroll();
        (0, _jquery2.default)(':focus').blur();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          size = _props.size,
          visible = _props.visible,
          children = _props.children,
          trigger = _props.trigger,
          onOpen = _props.onOpen,
          block = _props.block;
      var position = this.state.position;
      return _react2.default.createElement(DropDownContainer, {
        block: block
      }, _react2.default.createElement(DropDownContainer, {
        block: block,
        innerRef: function innerRef(dom) {
          return _this2.dom = dom;
        },
        onClick: onOpen
      }, trigger), _react2.default.createElement(_Portal2.default, {
        container: _assetsContainer.SECONDARY_ASSETS_CONTAINER_ID
      }, _react2.default.createElement(StyledDropDown, {
        width: size,
        visible: visible,
        position: position
      }, _react2.default.createElement(ClickArea, {
        onClick: this.onClose
      }), _react2.default.createElement(DropDownContent, {
        visible: visible
      }, children))));
    }
  }]);

  return DropDown;
}(_react.Component);

DropDown.propTypes = {
  visible: _propTypes2.default.bool.isRequired,
  onOpen: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  size: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  trigger: _propTypes2.default.node.isRequired,
  block: _propTypes2.default.bool
};
DropDown.defaultProps = {
  size: 300,
  block: false,
  onOpen: function onOpen() {
    return null;
  },
  onClose: function onClose() {
    return null;
  }
};
exports.default = (0, _reactOnclickoutside2.default)(DropDown);